import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { get, upperCase } from 'lodash';
import IdentityLogin from './IdentityLogin';
import ContactInformation from './ContactInformation';
import PostalAndPhone from '../SignUpWizard/PostalAndPhone';
import PracticeInformation from './PracticeInformation';
import StrengthsAndAvatar from './StrengthsAndAvatar';
import ProductMix from './ProductMix';
import PlanningInfo from './PlanningInfo';
import CandidateDescription from './CandidateDescription';
import NewInBusinessForm from './NewInBusinessForm';
import AdvisorLicenseComponent from '../SignUpWizard/AdvisorLicenseComponent';

class LoginOptionDialog extends PureComponent {
  STEPS = {
    NEW_IN_BUSINESS: 'NEW_IN_BUSINESS',
    CANDIDATE_DESCRIPTION: 'CANDIDATE_DESCRIPTION',
    PLANNING_INFO: 'PLANNING_INFO',
    STRENGTHS_AND_AVATAR: 'STRENGTHS_AND_AVATAR',
    PRACTICE_INFORMATION: 'PRACTICE_INFORMATION',
    PRODUCT_MIX: 'PRODUCT_MIX',
    POSTAL_AND_PHONE: 'POSTAL_AND_PHONE',
    LOGIN: 'LOGIN',
  };

  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      loginOption: null,
    };
  }

  featureEnabled = (featureName) => {
    const { features } = this.props;
    return features && features.includes(featureName);
  };

  renderModernDialog = () => {
    const company = get(this.props, 'user.company');
    const hasSamlOnly = this.featureEnabled('saml_login') && !this.featureEnabled('identity_authentication');
    
    return (
      <div style={{ 
        display: 'flex', 
        height: '500px',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
        maxWidth: hasSamlOnly ? '400px' : 'auto',
        margin: hasSamlOnly ? '0 auto' : 'auto'
      }}>
        {/* Left Panel - Welcome */}
        <div style={{
          flex: 1,
          padding: '40px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: 'white'
        }}>
          <h2 style={{
            fontSize: '28px',
            fontWeight: '700',
            color: '#6366f1',
            marginBottom: '16px',
            lineHeight: '1.2'
          }}>
            Welcome back!
          </h2>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            marginBottom: '32px',
            lineHeight: '1.5'
          }}>
            By creating an account and telling us a little bit about you, we&apos;ll keep you abreast of new opportunities
            and one of our {get(this.props, 'user.company.recruitment_team_word')} teammates will review your profile.
          </p>
          
          <Button 
            variant="contained" 
            onClick={() => this.setState({ loginOption: 'currentUser' })}
            style={{
              width: '100%',
              padding: '14px',
              background: '#6366f1',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              fontSize: '16px',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#5856eb';
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 4px 12px rgba(99, 102, 241, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#6366f1';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            SIGN IN
          </Button>
        </div>
        
        {/* Right Panel - Sign Up */}
        {!hasSamlOnly && (
          <div style={{
            flex: 1,
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            padding: '40px',
            color: 'white'
          }}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: '700',
              marginBottom: '16px',
              lineHeight: '1.2'
            }}>
              Don't have an account?
            </h2>
            <p style={{
              fontSize: '16px',
              opacity: '0.9',
              marginBottom: '32px',
              fontWeight: '400'
            }}>
              Start your journey in one click
            </p>
            
            <Button 
              onClick={() => window.location.href = '/onboarding'}
              style={{
                padding: '14px 32px',
                background: 'transparent',
                color: 'white',
                border: '2px solid white',
                borderRadius: '50px',
                fontSize: '16px',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'white';
                e.target.style.color = '#6366f1';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 8px 20px rgba(255, 255, 255, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = 'white';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}
            >
              SIGN UP
            </Button>
          </div>
        )}
      </div>
    );
  };

  renderClassicDialog = () => {
    const company = get(this.props, 'user.company');
    const hasSamlOnly = this.featureEnabled('saml_login') && !this.featureEnabled('identity_authentication');
    
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2 style={{ marginBottom: '20px' }}>
          Join Our Network
        </h2>
        <p style={{ marginBottom: '30px', color: '#666' }}>
          By creating an account and telling us a little bit about you, we&apos;ll keep you abreast of new opportunities
          and one of our {get(this.props, 'user.company.recruitment_team_word')} teammates will review your profile.
        </p>
        
        {!hasSamlOnly && (
          <div style={{ marginBottom: '15px' }}>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => this.featureEnabled('findbob_modernization') ? window.location.href = '/onboarding' : this.setState({ loginOption: 'create' })}
              style={{ width: '100%', marginBottom: '10px' }}
            >
              Continue Your Journey
            </Button>
          </div>
        )}

        <div>
          <Button 
            variant="outlined"
            onClick={() => this.setState({ loginOption: 'currentUser' })}
            style={{ width: '100%' }}
          >
            I already have an account - Sign In
          </Button>
        </div>
      </div>
    );
  };

  renderDialog = () => {
    return this.featureEnabled('findbob_modernization') 
      ? this.renderModernDialog() 
      : this.renderClassicDialog();
  };

  renderStep = step => {
    const {
      updateUser,
      updateProductMix,
      availableDesignations,
      availableStrengths,
      availableProducts,
      availableAdvisorLicenses,

      agentWord,
    } = this.props;
    const { loginOption } = this.state;
    const { STEPS } = this;
    const user = get(this.props, 'user', {});

    switch (step) {
      case STEPS.NEW_IN_BUSINESS:
        return (
          <NewInBusinessForm
            onNext={() => {
              window.location.reload();
            }}
          />
        );
      case STEPS.CANDIDATE_DESCRIPTION:
        return (
          <CandidateDescription
            opportunity={null}
            company={get(user, 'company')}
            onNext={() => {
              window.location.href = '/opportunities/thanks';
            }}
          />
        );
      case STEPS.STRENGTHS_AND_AVATAR:
        return (
          <StrengthsAndAvatar
            userId={user.tag_list}
            professionalStrengths={user.tag_list}
            updateAction={updateUser}
            availableDesignations={availableDesignations}
            designations={user.designations}
            assets_under_management={user.assets_under_management}
            availableStrengths={availableStrengths}
            modalTitle="Almost Done!"
            modalSubtitle="Tell us where your practice strengths lie and if you hold any professional designations."
            disableAvatar
            onNext={() => {
              window.location.reload();
            }}
            onBack={null}
          />
        );
      case STEPS.PRODUCT_MIX:
        const productMix = get(user, 'product_mix', {});

        return (
          <ProductMix
            userId={user.tag_list}
            user={user}
            updateAction={updateProductMix}
            life_ifp={productMix.life_ifp}
            home_ifp={productMix.home_ifp}
            auto_ifp={productMix.auto_ifp}
            commercial_ifp={productMix.commercial_ifp}
            health_ifp={productMix.health_ifp}
            group_ifp={productMix.group_ifp}
            mutual_funds_aum={productMix.mutual_funds_aum}
            securities_aum={productMix.securities_aum}
            annuities_aua={productMix.annuities_aua}
            segregated_funds_aua={productMix.segregated_funds_aua}
            mcpi_ifp={productMix.mcpi_ifp}
            private_products_ifp={productMix.private_products_ifp}
            crop_hail_ifp={productMix.crop_hail_ifp}
            crop_hail_with_wind_ifp={productMix.crop_hail_with_wind_ifp}
            farm_insurance_ifp={productMix.farm_insurance_ifp}
            price_products_ifp={productMix.price_products_ifp}
            replant_supplement_ifp={productMix.replant_supplement_ifp}
            availableProducts={availableProducts}
            fullName={user.name}
            modalTitle="Almost Done!"
            modalSubtitle="Tell us where your practice strengths lie and if you hold any professional designations."
            disableAvatar
            onNext={() => {
              window.location.reload();
            }}
            onBack={null}
            requiredFields={[
              'product_mix.life_ifp',
              'product_mix.home_ifp',
              'product_mix.auto_ifp',
              'product_mix.commercial_ifp',
              'product_mix.group_ifp',
              'product_mix.health_ifp',
              'product_mix.mutual_funds_aum',
              'product_mix.securities_aum',
              'product_mix.annuities_aua',
              'product_mix.segregated_funds_aua',
              'product_mix.mcpi_ifp',
              'product_mix.private_products_ifp',
              'product_mix.crop_hail_ifp',
              'product_mix.crop_hail_with_wind_ifp',
              'product_mix.farm_insurance_ifp',
              'product_mix.price_products_ifp',
              'product_mix.replant_supplement_ifp',
            ]}
            companyIsWealthType={(get(user, 'company.business_type') === 'wealth' ||
              get(user, 'company.business_type') === 'wealth_rj')}>

            {(get(user, 'company.business_type') === 'wealth' || get(user, 'company.business_type') === 'wealth_rj') && (
              <AdvisorLicenseComponent
                availableAdvisorLicenses={availableAdvisorLicenses}
                updateAction={updateUser}
                userAdvisorLicenses={user.advisor_licenses}
              />
            )}
          </ProductMix>
        );
      case STEPS.PLANNING_INFO:
        return (
          <PlanningInfo
            user={user}
            updateAction={updateUser}
            company={get(user, 'company')}
            onBack={null}
            onNext={() => {
              window.location.reload();
            }}
            agentWord={agentWord}
          />
        );
      case STEPS.PRACTICE_INFORMATION:
        return (
          <PracticeInformation
            year_career_began={user.year_career_began}
            years_practicing={user.years_practicing}
            number_of_clients={user.number_of_clients}
            avg_client_age={user.avg_client_age}
            annual_revenue={user.annual_revenue}
            percent_commission={user.percent_commission || 100}
            percent_fee_based={user.percent_fee_based || 0}
            recurring_revenue={user.recurring_revenue}
            percent_revenue_recurring={user.percent_revenue_recurring}
            percent_non_recurring_revenue={user.percent_non_recurring_revenue}
            transition_goals={user.transition_goals || []}
            locale={user.locale}
            updateAction={updateUser}
            modalTitle="Tell Us More!"
            modalSubtitle="Tell us a bit about your practice to help us understand where you're at in your career and allow us to curate opportunities internally."
            onNext={() => {
              window.location.reload();
            }}
          />
        );
      case STEPS.POSTAL_AND_PHONE:
        return (
          <PostalAndPhone
            postal_code={user.postal_code}
            phone_number={user.phone_number}
            allowEmail={false}
            updateAction={updateUser}
            modalTitle="Tell Us More!"
            modalSubtitle="Tell us a bit about your practice to help us understand where you're at in your career and allow us to curate opportunities internally."
            displayBusinessQuestion
            onNext={() => {
              this.forceUpdate();
            }}
          />
        );
      default:
        return this.loginOptions()[loginOption || 'null'];
    }
  };

  titleForStep = step => {
    const { STEPS } = this;
    const { showIdentity } = this.state;
    const { user } = this.props;
    const company = get(user, 'company');

    switch (step) {
      case STEPS.CANDIDATE_DESCRIPTION:
        return 'Tell Us Why';
      case STEPS.NEW_IN_BUSINESS:
      case STEPS.STRENGTHS_AND_AVATAR:
      case STEPS.PRACTICE_INFORMATION:
      case STEPS.POSTAL_AND_PHONE:
      default:
        return showIdentity
          ? 'Sign in to your account'
          : `Interested in becoming ${this.returnA(get(company, 'display_name'))} ${get(company, 'display_name')} ${get(
            company,
            'recruitment_agent_word'
          )}?`;
    }
  };

  getCurrentStep = () => {
    const { STEPS } = this;
    const user = get(this.props, 'user');

    if (get(user, 'id')) {
      if (user.has_postal_code) {
        if (user.new_in_industry) {
          if (!user.has_candidate_profile) {
            return STEPS.NEW_IN_BUSINESS;
          }
          return STEPS.CANDIDATE_DESCRIPTION;
        }
        if (user.planning_info_complete) {
          return STEPS.CANDIDATE_DESCRIPTION;
        }
        if (user.product_mix_complete) {
          return STEPS.PLANNING_INFO;
        }
        if (user.strengths_complete) {
          return STEPS.PRODUCT_MIX;
        }
        if (user.practice_complete) {
          return STEPS.STRENGTHS_AND_AVATAR;
        }

        return STEPS.PRACTICE_INFORMATION;
      }
      return STEPS.POSTAL_AND_PHONE;
    }
    return STEPS.LOGIN;
  };

  loginOptions = () => ({
    null: this.renderDialog(),
    currentUser: <IdentityLogin />,
    create: (
      <ContactInformation
        onCreate={() => {
          window.location.reload();
        }}
      />
    ),
    linkedIn: <div>LinkedIn placeholder</div>,
  });

  returnA = name => {
    const char = upperCase(name.charAt(0));
    if (char === 'A' || char === 'E' || char === 'I' || char === 'O' || char === 'U') {
      return 'an';
    }
    return 'a';
  };

  render() {
    const { fullScreen, user } = this.props;
    const company = get(user, 'company');
    const { open, showIdentity } = this.state;
    const step = this.getCurrentStep();
    const isModern = this.featureEnabled('findbob_modernization');

    const modernPaperProps = {
      style: {
        borderRadius: fullScreen ? 0 : '20px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
        border: 'none',
        overflow: 'hidden',
        maxWidth: '800px',
        width: '90vw'
      }
    };

    const classicPaperProps = {
      style: {
        borderRadius: fullScreen ? 0 : '4px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden'
      }
    };

    const modernBackdropProps = {
      style: {
        backgroundColor: 'rgba(0, 0, 0, 0.3)'
      }
    };

    const classicBackdropProps = {
      style: {
        backgroundColor: 'rgba(0, 0, 0, 0.3)'
      }
    };

    const classicTitleStyle = {
      padding: '16px 24px',
      fontSize: '20px',
      fontWeight: 500,
      color: '#333333',
      backgroundColor: '#f5f5f5'
    };

    return (
      <Dialog 
        open={open} 
        aria-labelledby="form-dialog-title" 
        fullScreen={fullScreen}
        PaperProps={isModern ? modernPaperProps : classicPaperProps}
        BackdropProps={isModern ? modernBackdropProps : classicBackdropProps}
      >
        {!isModern && (
          <DialogTitle 
            id="form-dialog-title" 
            className="text-center"
            style={classicTitleStyle}
          >
            {showIdentity ? (
              'Sign in to your account'
            ) : (
                `Interested in becoming ${this.returnA(get(company, 'display_name'))} ${get(company, 'display_name')} ${get(
                  company,
                  'recruitment_agent_word'
                )}?`
              )}
          </DialogTitle>
        )}
        <DialogContent 
          style={{
            padding: 0,
            backgroundColor: '#ffffff'
          }}
        >
          {this.renderStep(step)}
        </DialogContent>
      </Dialog>
    );
  }
}

LoginOptionDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool,
  updateUser: PropTypes.func.isRequired,
  availableDesignations: PropTypes.array,
  availableStrengths: PropTypes.array,
  history: PropTypes.object,
  features: PropTypes.array,
};

LoginOptionDialog.defaultProps = {
  open: false,
  availableDesignations: [],
  availableStrengths: [],
  history: {},
  features: [],
};

const styles = {
  // Keeping minimal styles for backward compatibility
  // Most styling is now handled with Tailwind/inline styles
};

export default withStyles(styles)(withMobileDialog()(LoginOptionDialog));
